import AppModuleStore from './schema/AppModuleStore';
import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import { Banner } from './schema/Banner';
import { createStore } from 'satcheljs';

const store = createStore<AppModuleStore>('appModule', {
    module: null,
    shownBanner: Banner.None,
    offlineSyncStatus: AsyncStatus.Idle,
})();

export const getStore = () => store;
